import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
            "Software Engineer",
            "Full Stack Developer",
            ".NET Developer",
            "Microservices Developer",
            "React Developer",
            "Cloud & DevOps Enthusiast",
            "Backend Engineer",
            "Problem Solver",
            "Tech Explorer"
          ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
